var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncreaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 10C5.55228 10 6 9.55228 6 9L6 6H9C9.55228 6 10 5.55228 10 5C10 4.44772 9.55228 4 9 4L6 4L6 1C6 0.447715 5.55229 0 5 0C4.44772 0 4 0.447715 4 1L4 4L1 4C0.447715 4 0 4.44771 0 5C0 5.55228 0.447715 6 1 6H4L4 9C4 9.55228 4.44772 10 5 10Z",
    fill: "#1FA37C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseIcon);
export default __webpack_public_path__ + "static/media/increaseIcon.59372b283c766939424ab846b5198359.svg";
export { ForwardRef as ReactComponent };